<template>
  <div id="setup-and-start">
    <div v-if="haveMultipleLanguages && available_languages">
      <div v-if="section === 'languageSelect'" id="languageSelection">
        <h2>Exam Language</h2>
        <p>
          This exam is availble in multiple languages; please select one, considering the fact that you will
          not be able to change this in the middle of the exam:
        </p>
        <select @change="changeSelectedLanguage($event)">
          <template v-if="noLanguageSelected">
            <option value="" disabled selected>Select a language</option>
          </template>

          <option
            v-for="language in available_languages"
            :key="language.lang"
            :value="language.lang"
            :selected="selected_language && selected_language.lang === language.lang"
            >{{ language.local_title }}</option
          >
        </select>
      </div>

      <div v-if="section === 'languageConfirm'" id="languageConfirmation">
        <h2>Exam Language</h2>
        <p>
          Attention: You will not be able to change the language after you start the exam. Please make sure
          you've selected an appropriate language.
        </p>
        <button @click="languageConfirmed" class="danger">
          I Understand
        </button>
      </div>
    </div>

    <div id="invigilation" v-if="examIsInvigilated">
      <h2>Invigilation Setup</h2>

      <p>
        This exam is invigilated: your audio, webcam video, and desktop applications will be recorded during
        the exam. You need to follow the setup process below to activate invigilation and enable the exam:
      </p>

      <p class="setup" @click="invigilateSetupClicked">
        Invigilation Setup »
      </p>
    </div>

    <div id="startbutton">
      <button
        class="largebutton"
        @click="startButtonClicked"
        :disabled="startButtonDisabled || disable_start_doubleclick || section === 'languageConfirm'"
      >
        Start the Exam
      </button>

      <p v-if="haveMultipleLanguages && !noLanguageSelected">
        <span v-if="section === 'languageConfirm'">
          ✘ You have not confirmed the exam language.
        </span>
        <span v-else> ✔ You have selected the {{ selected_language.english_title }} exam.</span>
      </p>
      <p v-if="haveMultipleLanguages && noLanguageSelected">
        ✘ You have not selected the exam language.
      </p>

      <div v-if="examIsInvigilated">
        <p v-if="exam_details.invigilated && initialInvigilateFulfilled">
          ✔ Your invigilation setup is done and you can start the exam.
        </p>
        <p v-if="exam_details.invigilated && !initialInvigilateFulfilled">
          ✘ Your invigilation setup is NOT done yet.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      showLanguageSelector: false,
      // to disable double click on start button and start exam twice
      disable_start_doubleclick: false,
      section: 'languageSelect' // options:  languageSelect, languageConfirm
    }
  },
  methods: {
    changeSelectedLanguage($event) {
      let lang = $event.target.value
      this.$store.dispatch('language/changeSelectedLanguage', lang)
      this.section = 'languageConfirm'
    },
    startButtonClicked() {
      this.disable_start_doubleclick = true
      this.$store.dispatch('exam/preStartCheckLevelOne')
    },
    languageConfirmed() {
      this.section = 'languageSelect'
      this.change_language_confirmed = true
    },

    invigilateSetupClicked() {
      this.$store.dispatch('invigilate/showInvigilateSetup')
    }
  },
  computed: {
    ...mapState('language', ['selected_language', 'available_languages']),
    ...mapGetters('language', ['haveMultipleLanguages', 'noLanguageSelected']),
    ...mapGetters('invigilate', ['initialInvigilateFulfilled']),
    ...mapState('exam', ['exam_details']),
    ...mapState('invigilate', ['webcam_status']),
    ...mapGetters(['examIsInvigilated']),

    startButtonDisabled() {
      if (!this.examIsInvigilated) {
        return false
      }

      if (
        (this.exam_details.invigilated && !this.initialInvigilateFulfilled) ||
        (this.haveMultipleLanguages && this.noLanguageSelected)
      ) {
        return true
      }
      return false
    }
  },

  watch: {
    // initialInvigilateFulfilled(value) {
    //   if (value === false) {
    //     this.startButtonDisabled = true
    //   }
    // },
    // selected_language() {},
  },

  mounted() {
    // if (
    //   (this.exam_details.invigilated && !this.initialInvigilateFulfilled) ||
    //   (this.haveMultipleLanguages && this.noLanguageSelected)
    // ) {
    //   this.startButtonDisabled = true
    // }
  }
}
</script>
